import PropTypes from 'prop-types'

const FlagEN = ({ width = '22', height = '16', ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 60 30"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <defs>
      <clipPath id="flag-en-round">
        <rect width="60" height="30" rx="4" />
      </clipPath>
      <clipPath id="flag-en-t">
        <path d="M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z" />
      </clipPath>
    </defs>
    <g clipPath="url(#flag-en-round)">
      <path d="M0,0 v30 h60 v-30 z" fill="#012169" />
      <path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" strokeWidth="6" />
      <path
        d="M0,0 L60,30 M60,0 L0,30"
        clipPath="url(#flag-en-t)"
        stroke="#C8102E"
        strokeWidth="4"
      />
      <path d="M30,0 v30 M0,15 h60" stroke="#fff" strokeWidth="10" />
      <path d="M30,0 v30 M0,15 h60" stroke="#C8102E" strokeWidth="6" />
    </g>
  </svg>
)

FlagEN.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
}

export default FlagEN
